import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasFormGroup = ({
  children,
  className,
  row,
  // eslint-disable-next-line no-unused-vars
  sx,
  ...props
}) => (
  <div className={cn('flex', row ? 'flex-row gap-4 flex-wrap' : 'flex-col gap-2', className)} {...props}>
    {children}
  </div>
)

AdasFormGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  row: PropTypes.bool
}
